import BaseStore from './BaseStore'

export class SiteSettingStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'site_settings'
  }
}

export default new SiteSettingStore()


// WEBPACK FOOTER //
// ./src/stores/SiteSettingStore.js